import { Site } from "interfaces/kpis";

export const getPercentageAcrossSites = (sites: Site[]): number => {
  if (!sites.length) {
    return 0;
  }

  const { satisfiedTargets, totalTargets } = sites.reduce(
    (prev, curr) => {
      const {
        target_machines,
        target_machines_overridden,
        target_machines_with_achievements
      } = curr.progress;

      if (target_machines === 0) {
        return prev;
      }

      prev.satisfiedTargets +=
        target_machines_with_achievements + target_machines_overridden;

      prev.totalTargets += target_machines;

      return {
        satisfiedTargets: prev.satisfiedTargets,
        totalTargets: prev.totalTargets
      };
    },
    { satisfiedTargets: 0, totalTargets: 0 } as {
      satisfiedTargets: number;
      totalTargets: number;
    }
  );

  if (!totalTargets) {
    return 0;
  }

  return Math.floor((100 * satisfiedTargets) / totalTargets);
};
